import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AngularFireAnalytics } from '@angular/fire/compat/analytics';
import { Observable } from 'rxjs/internal/Observable';
import { of } from 'rxjs/internal/observable/of';
import { tap } from 'rxjs/internal/operators/tap';
import { CacheResolverService } from './cache-resolver.service';
const TIME_TO_LIVE = 600;

@Injectable()
export class CacheInterceptor implements HttpInterceptor {
    constructor(
        private cacheResolver: CacheResolverService,
        private analytics: AngularFireAnalytics
    ) {}
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        const urls = [
            'member/crp-lakhpati-map/redis-listing',
            // '/member/lakhpatididi'
        ];

        const isPermissible = urls.some((url: string) => req.urlWithParams.includes(url));
        if (!isPermissible) {
            return next.handle(req);
        }
        const cachedResponse = this.cacheResolver.get(req.urlWithParams);
        // console.log('cachedResponse', cachedResponse);
        return cachedResponse ? of(cachedResponse) : this.sendRequest(req, next);
    }

    sendRequest(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            tap((event) => {
                if (event instanceof HttpResponse) {
                    this.cacheResolver.set(req.urlWithParams, event, TIME_TO_LIVE);
                }
            })
        );
    }
}
